// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar__banner[data-v-ffc0f1bc]{margin-bottom:24px}", ""]);
// Exports
module.exports = exports;
